import { useState } from 'react'
import { Link, useRouteError } from 'react-router-dom'
import { flushCheckpoints } from '@/platform/lifecycle/checkpoints'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const [busy, setBusy] = useState(false)
  const [saveFailed, setSaveFailed] = useState(false)
  const isChunkError = error instanceof Error && /dynamically imported module|chunk|module script/i.test(error.message)
  const reload = async () => {
    setBusy(true)
    if (await flushCheckpoints('exit')) window.location.reload()
    else { setSaveFailed(true); setBusy(false) }
  }
  return <main className="grid min-h-dvh place-items-center bg-orange-50 px-5">
    <section className="w-full max-w-sm rounded-3xl border border-orange-100 bg-white p-7 text-center">
      <h1 className="text-xl font-bold">{isChunkError ? 'Chưa tải được nội dung' : 'Không thể mở trang'}</h1>
      <p role="status" className="mt-3 text-sm text-slate-600">{saveFailed ? 'Chưa lưu được tiến độ. Vui lòng giữ trang và thử lại khi có mạng.' : 'Kiểm tra kết nối rồi thử lại nhé.'}</p>
      <button disabled={busy} onClick={() => void reload()} className="mt-5 min-h-11 rounded-xl bg-blue-600 px-5 font-bold text-white">{busy ? 'Đang lưu…' : 'Tải lại'}</button>
      <Link to="/" className="mt-3 block min-h-11 p-3 font-bold text-blue-700">Trang chủ</Link>
    </section>
  </main>
}
